import { render, staticRenderFns } from "./CalendarComponent.vue?vue&type=template&id=a06b3f4a&scoped=true"
import script from "./CalendarComponent.vue?vue&type=script&lang=js"
export * from "./CalendarComponent.vue?vue&type=script&lang=js"
import style0 from "./CalendarComponent.scss?vue&type=style&index=0&id=a06b3f4a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06b3f4a",
  null
  
)

export default component.exports